<template>
  <!-- 会员中心-互助会员 -->
  <div>
    <div class="mutualMember">
      <!-- 头部查询表单 -->
      <div class="headForm">
        <div class="head">会员等级权益</div>
        <div class="input-form-box" style="margin-top: 20px">
          <formOne :pageName="pageName" @onSerach="searchFormOne"></formOne>
        </div>
      </div>

      <div class="content">
        <!-- 表格 -->
        <div>
          <el-button style="margin-bottom:15px" type="primary"   @click="createBtn(null, 'add')">新增权益</el-button>
        </div>
        <el-table
          :data="tableData"
          v-loading="talbeLoading"
          style="width: 100%; margintop: 20px"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img
                class="no_goods_img"
                src="@/assets/images/default/暂无任何数据.png"
              />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column
            prop="memberNick"
            label="权益图标"
            width="200"
          >
            <template slot-scope="scope">
                <img class="benefit-icon" :src="scope.row.benefitEnableIconUrl" />
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="权益名称"
            width="200"
          ></el-table-column>
          <el-table-column prop="jumpInfo" label="跳转链接" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.jumpInfo}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
          ></el-table-column>
          <el-table-column
            prop="updateTime"
            label="最后修改时间"
          ></el-table-column>
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <div class="btns">
                <!-- 修改 -->
                <span
                  class="b1"
                 @click="onCreateBenefit(scope.row, 'edit')"
                  >编辑</span
                >
    
                <!-- 删除 -->
                <span
                  class="b2"
                  @click="onDelete(scope.row.id)"
                  >删除</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="numTotal"
        ></el-pagination>
      </div>
    </div>
    <!-- 新增权益 -->
    <AddBenefit
      v-model="isShowAddOrEdit"
      :controlType="controlType"
      :rowData="rowData"
      @update="recordQuery"
    />
  </div>
</template>

<script>
import topTitle from "../../../components/top-title";
import AddBenefit from "./AddBenefit.vue";
import {
    getMemberBenefitInfo,
    createMemberBenefitInfo,
    deleteMemberBenefitInfo,
} from "@/api/integralCenter/level";
import formOne from "../inputFrom/input_form_one";
export default {
  name: "levelPrivilege",
  filters: {
    statusStr(status) {
      return { 0: "未开卡", 1: "已开卡", null: "null" }[status];
    },
  },
  components: {
    topTitle,
    AddBenefit,
    formOne,
  },
  data() {
    return {
      rowData: {},
      controlType: "add",
      isShowAddOrEdit:false,
      pageName: "忠诚度管理-互动会员",
      numTotal: 0,
      totalNum: 0,
      //会员信息弹框
      levelInfo: false,
      form: {
        resource: "1",
      },
      formLabelWidth: "150px",
      value1: "",
      //积分日志弹框
      pointLog: false,
      logCurrentPage: 1,
      gridData: [],
      //积分变更弹框
      changePonit: false,
      // 头部表单配置项
      inputData: [
        {
          name: "会员昵称:",
          val: "nick",
          placeholder: "请输入会员昵称",
        },
        // {
        //   name: "客户pin:",
        //   val: "pin",
        //   placeholder: "请输入客户pin",
        // },
        {
          name: "手机号码:",
          val: "mobile",
          placeholder: "请输入手机号码",
        },
        {
          name: "会员等级:",
          val: "memberLevel",
          selectArr: [
            { label: "一星会员", id: 1 },
            { label: "二星会员", id: 2 },
            { label: "三星会员", id: 3 },
            { label: "四星会员", id: 4 },
            { label: "五星会员", id: 5 },
          ],
        },
        {
          name: "是否开卡:",
          val: "memberLevel",
          selectArr: [
            { label: "已开卡", id: 1 },
            { label: "未开卡", id: 0 },
          ],
        },
        {
          name: "开卡时间:",
          myDate: true,
          val: ["cardStartTime", "cardEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "最后参与活动时间:",
          myDate: true,
          val: ["lastStartTime", "lastEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      talbeLoading: false, // 控制表格loading状态
      tableData: [], // 表格数据
      currentPage: 1, // 表格当前页
      levelData: {
        current: 1,
        size: 10,
      },
      formData: {}, //积分日志
      formDataOne: {
        memberNick: "", //名称
        score: "", //当前积分
        sourceType: "27", //发放/扣除
        points: "", //变更积分值
        sourceComment: "", //备注
        memberId: "",
      }, //积分变更
      activationStatus: "",
      log: {
        size: 10,
        current: 1,
      },
      ids: "",
      mytimestart: "",
      mytimeend: "",
      opentime: true,
    };
  },
  created() {
    this.buriedPoint(1, "云起互动", "互动会员", "会员等级权益");
  },
  mounted() {
    this.memberList();
  },
  methods: {
    //删除
    onDelete(value) {
      let params = {
        id: value
      }
      deleteMemberBenefitInfo(params).then((res) => {
        this.$message.success('删除成功')
        this.memberList();
      });
    },
    //获取列表数据
    memberList() {
      this.talbeLoading = true;
      getMemberBenefitInfo(this.levelData).then((res) => {
        if (res.code == 1) {
          this.talbeLoading = false;
          this.tableData = res.data.records;
          this.numTotal = Number(res.data.total);
        }
      });
    },
    //查询
    searchFormOne(val) {
      this.logCurrentPage = 1;
      this.levelData.name = val.theme;
      this.levelData.createStartTime = val.orderStartTimeStart;
      this.levelData.createEndTime = val.orderStartTimeEnd;
      this.levelData.updateStartTime = val.sendStartTimeStart;
      this.levelData.updateEndTime = val.sendStartTimeEnd;
      this.levelData.current = 1;
      this.levelData.size = 10;
      this.memberList();
    },
    /**
     * 分页变化事件
     */
    handleSizeChange(val) {
      this.levelData.size = val;
      this.memberList();
    },
    handleCurrentChange(val) {
      this.levelData.current = val;
      this.memberList();
    },
    //添加，编辑
    onCreateBenefit(row, type) {
      this.isShowAddOrEdit = true;
      this.controlType = type;
      if (type == "edit") {
        this.rowData = { ...row };
      } else {
        this.rowData = {};
      }
    },
    recordQuery(form) {
      this.memberList();
    },
    createBtn(row, type){
      this.isShowAddOrEdit = true;
      this.controlType = type;
      if (type == "edit") {
        this.rowData = { ...row };
      } else {
        this.rowData = {};
      }
    },
    
  },
};
</script>

<style scoped lang="scss">
.dateClass {
  /deep/.el-input__inner {
    text-indent: 20px;
  }
}
.mutualMember {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1080px;
  .headForm {
    box-sizing: border-box;
    margin-top: 20px;
    padding: 24px 0 30px 0;
    background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .head {
      border-bottom: 1px solid #f0f0f0;
      padding: 0 0 20px 50px;
      font-size: 16px;
      font-weight: bold;
      color: #2e3458;
    }
  }
  .content {
    box-sizing: border-box;
    padding: 24px 28px 30px;
    background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin: 20px 0 50px 0;
    .btns {
      display: flex;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      span {
        padding: 10px 2px;
      }
      .b1 {
        cursor: pointer;
        color: #2670fb;
        &:hover {
          color: #2670fb;
        }
      }
      .b2 {
        margin: 0 30px;
        cursor: pointer;
        color: #2670fb;
        &:hover {
          color: #2670fb;
        }
      }
      .img3 {
        height: 18px;
        // position: flex;
        margin: 0 0 -4px 0;
      }
      .b3 {
        cursor: pointer;
        color: #2670fb;
        &:hover {
          color: #2670fb;
        }
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
  .benefit-icon {
      width: 70px;
      height: 70px;
    }
}
</style>
